import { render, staticRenderFns } from "./App.vue?vue&type=template&id=706458a4"
import script from "./App.vue?vue&type=script&lang=javascript"
export * from "./App.vue?vue&type=script&lang=javascript"
import style0 from "./App.vue?vue&type=style&index=0&id=706458a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports